import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContent,[_c(VToolbar,{staticStyle:{"top":"64px"},attrs:{"fixed":"","id":"project-toolbar"}},[_c(VToolbarTitle,[_vm._v("ヘルプ")]),_c(VSpacer),_c(VToolbarItems,{},[_c(VBtn,{attrs:{"flat":"","to":{name: 'help.manual'}}},[_vm._v("マニュアル")]),_c(VBtn,{attrs:{"flat":"","to":{name: 'help.questions'}}},[_vm._v("Q&A")])],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }